<template>
  <v-container fluid>
    <v-card>
      <v-system-bar>MA-Präsentationen importieren</v-system-bar>
      <v-card-text v-if="importStatus.importRunning">
        Die MA-Präsentationen werden importiert:
        {{ importStatus.importProgress }} von
        {{ importStatus.importCount }} Anlässen verarbeitet.
        <v-progress-linear
          :value="
            (importStatus.importProgress / importStatus.importCount) * 100
          "
          class="my-2"
        ></v-progress-linear>

        <p
          class="text-caption text-medium-emphasis"
          v-for="(msg, index) in importStatus.importMessages"
          :key="index"
          v-html="msg"
        ></p>
      </v-card-text>
      <v-card-text v-else>
        <p>Wähle die Untis-Datei zum Hochladen aus.</p>
        <v-row>
          <v-col cols="12" md="6">
            <form ref="untisUploadForm">
              <v-file-input
                name="file"
                v-model="uploadFile"
                label="Untis-Datei"
              ></v-file-input>
            </form>
          </v-col>
          <v-col cols="12" md="6">
            <DateInput
              v-model="presentationDate"
              label="Tag der Präsentationen"
              required
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer /><v-btn
          outlined
          color="primary"
          @click="upload"
          :disabled="!canUpload"
          text
          >importieren</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { defineComponent } from "vue";
import DateValue from "common/components/DateValue.vue";
import DateInput from "common/components/DateInput.vue";
import TimeValue from "common/components/TimeValue.vue";
export default defineComponent({
  name: "MAUpload",
  components: { DateValue, DateInput, TimeValue },
  data() {
    return {
      presentationDate: null,
      importStatus: {},
      uploadFile: {
        name: "",
      },
      timeout: null,
    };
  },
  computed: {
    canUpload() {
      return this.presentationDate && this.uploadFile.name;
    },
  },
  async created() {
    this.update();
  },
  beforeRouteLeave(to, from, next) {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    next();
  },
  methods: {
    async upload() {
      var formElement = this.$refs.untisUploadForm;
      await this.apiUploadPost({
        resource: `automation/thesistimes?presentationDate=${this.presentationDate}`,
        form: formElement,
      });
      await this.update();
    },
    async update() {
      this.importStatus = await this.apiList({
        resource: "automation/thesistimes",
      });
      if (this.importStatus.importRunning) {
        this.timeout = setTimeout(this.update, 1000);
      }
    },
  },
});
</script>
